// extracted by mini-css-extract-plugin
export var colorPicker = "styles-module--colorPicker--b596e";
export var heading = "styles-module--heading--3dd81";
export var outOfStockText = "styles-module--outOfStockText--290ad";
export var subtitle = "styles-module--subtitle--fde84";
export var visible = "styles-module--visible--553c4";